<ssc-layouted-overlay (closed)="isOpen = false" *ngIf="isOpen" title="Dev Tools">
  <div content>
    <dap-lib-button (click)="fillContactData()" variant="primary">Kontaktdaten ausfüllen </dap-lib-button>
    <dap-lib-button (click)="skipToAssistant()" variant="primary"
      >Skip to Assistant (choose language in footer before)
    </dap-lib-button>
    <p>
      If you want to validate the order, click on
      <strong>"{{ 'SUMMARY.NAVIGATION_BAR.ORDER_OFFER' | translate }}"</strong>
    </p>
  </div>

  <div primary-action>
    <dap-lib-button (click)="isOpen = false" buttonSize="small" variant="tertiary">Schliessen </dap-lib-button>
  </div>
</ssc-layouted-overlay>
<dap-lib-overlay-loader *ngIf="showLoader$ | async"></dap-lib-overlay-loader>
